import {
  STOCK_TAKING_CAR_MANAGEMENT_DELETE_IMAGE_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_DELETE_IMAGE_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_DELETE_IMAGE_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_TAKING_CAR_MANAGEMENT_DELETE_IMAGE_BEGIN:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          fastStockLoading: {
            ...state.takingCarManagement.fastStockLoading,
            errorDeleteFileImage: null
          }
        }
      }

    case STOCK_TAKING_CAR_MANAGEMENT_DELETE_IMAGE_SUCCESS:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          fastStockLoading: {
            ...state.takingCarManagement.fastStockLoading,
            errorDeleteFileImage: null,
            saveData: {
              ...state.takingCarManagement.fastStockLoading.saveData,
              files: action.data
            }
          }
        }
      }

    case STOCK_TAKING_CAR_MANAGEMENT_DELETE_IMAGE_FAILURE:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          fastStockLoading: {
            ...state.takingCarManagement.fastStockLoading,
            errorDeleteFileImage: "Error al borrar la imagen.",
          }
        }
      }

    default:
      return state
  }
}
